export default {
  methods: {
    displayMessage(message, isError) {
      this.$buefy.toast.open({
        message: message,
        type: isError ? 'is-danger' : 'is-success',
        pauseOnHover: true,
        dismissible: true,
        duration: 5000
      })
    }
  }
}